module.exports = __webpack_public_path__ + "static/media/stopped.16aa743a.ico";